import { Col, Container, Row } from "react-bootstrap";
import SalaEspera from "../autoagendamientov2/SalaEspera";

export default function OnCitaNoComienzaV2({items, onCompleteTimeStart}){   

    return (
        <Container className="mt--20">
            <Row>
                <Col xs="12" md={{span: 10, offset: 1}}>                    
                    <SalaEspera items={items} onCompleteTimeStart={onCompleteTimeStart}/>
                </Col>
            </Row>
        </Container>
        
    )

}